import Collapse from "blocks.simple/collapse/collapse"
import { cn } from "ethcss"
import styles from '../settings.jcss'
import translate from "core/translate"
import React, { useEffect, useState } from "react"
import Button from "blocks.simple/button/button"
import { Typography } from "atoms/Typography"
import { grid, text as textStyles } from 'theme'
import { Radio } from "atoms/Radio"
import { useDispatch, useSelector } from "react-redux"
import { updateUserSettings } from "blocks.app/user/user.state"


const MoveModalSettings = () => {
    const dispatch = useDispatch()
    const userMoveSettings = useSelector((state: any) => state.user.data.settings.digitalSignage || {
        groupScheduleMode: 'askEveryTime',
        overwriteSettings: 'askEveryTime'
    })
    const [moveSettings, setMoveSettings] = useState(userMoveSettings)

    useEffect(() => {
        dispatch(updateUserSettings({ data: { digitalSignage: moveSettings }, isSaveSettings: true }))
    }, [moveSettings])

    return (
        <Collapse title={() => translate('devices')} className={cn(styles.background, grid.mb_md)}>
            <div className={styles.wrapper}>
                <div className={grid.mt_mdPlus}>
                    <Typography
                        type="title"
                        className={cn(
                            textStyles.centerBlock,
                            textStyles.up,
                            textStyles['normalPlus']
                        )}
                    >
                        {translate('scheduleForDevice')}
                    </Typography>
                    <Radio
                        className={cn(grid.mt_md)}
                        label={
                            <Typography type="title">
                                {translate('changeCurrentSchedule')}
                            </Typography>
                        }
                        selected={moveSettings.groupScheduleMode === 'apply'}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                groupScheduleMode: 'apply'
                            })
                        }}
                    />
                    <Radio
                        className={cn(grid.mt_mini)}
                        label={
                            <Typography type="title">
                                {translate('remainCurrentSchedule')}
                            </Typography>
                        }
                        selected={moveSettings.groupScheduleMode === 'ignore'}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                groupScheduleMode: 'ignore'
                            })
                        }}
                    />
                    <Radio
                        className={cn(grid.mt_mini)}
                        label={
                            <Typography type="title">
                                {translate('askEveryTime')}
                            </Typography>
                        }
                        selected={moveSettings.groupScheduleMode === 'askEveryTime'}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                groupScheduleMode: 'askEveryTime'
                            })
                        }}
                    />
                </div>
                <div className={grid.mt_mdPlus}>
                    <Typography
                        type="title"
                        className={cn(
                            textStyles.centerBlock,
                            textStyles.up,
                            textStyles['normalPlus']
                        )}
                    >
                        {translate('groupAndDevicesSettingsOnMove')}
                    </Typography>
                    <Radio
                        className={cn(grid.mt_md)}
                        label={
                            <Typography type="title">
                                {translate('replaceWithParentSettings')}
                            </Typography>
                        }
                        selected={moveSettings.overwriteSettings === true}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                overwriteSettings: true
                            })
                        }}
                    />
                    <Radio
                        className={cn(grid.mt_mini)}
                        label={
                            <Typography type="title">
                                {translate('keepCurrentSettings')}
                            </Typography>
                        }
                        selected={moveSettings.overwriteSettings === false}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                overwriteSettings: false
                            })
                        }}
                    />
                    <Radio
                        className={cn(grid.mt_mini)}
                        label={
                            <Typography type="title">
                                {translate('askEveryTime')}
                            </Typography>
                        }
                        selected={moveSettings.overwriteSettings === 'askEveryTime'}
                        onClick={function () {
                            setMoveSettings({
                                ...moveSettings,
                                overwriteSettings: 'askEveryTime'
                            })
                        }}
                    />
                </div>
            </div>
        </Collapse>
    )

}

export default MoveModalSettings